import { getDb } from '@/utils/firebase'
import firebase from 'firebase/app'

const getFeedback = async () => {
  try {
    const db = getDb()
    const querySnapshot = await db.collection('feedback').get()
    const feedbackItems = querySnapshot.docs.map(doc => {
      const item = doc.data()
      const date = item.date || 0
      return {
        ...item,
        date,
        id: doc.id
      }
    })
    return feedbackItems
  } catch (e) {
    console.log(e)
  }
}

const sendFeedback = async ({ feedback, user, sendFeedbackAnonymous }) => {
  const db = getDb()
  await db.collection('feedback').add({
    date: Date.now(),
    feedback,
    user: user && !sendFeedbackAnonymous ? user.email : null
  })
  return true
}

const getNotes = async userUid => {
  const db = getDb()
  const docRef = db.collection('pages').doc(userUid)
  const doc = await docRef.get()
  if (doc.exists) {
    const notes = doc.data()
    if (Object.keys(notes).length > 0) {
      return notes
    } else {
      return {}
    }
  } else {
    return {}
  }
}

const setNotes = async (userUid, notes) => {
  const db = getDb()
  await db.collection('pages').doc(userUid).set(notes)
  return true
}

const deleteNote = async (userUid, noteId) => {
  const db = getDb()
  await db.collection('pages').doc(userUid).update({
    [noteId]: firebase.firestore.FieldValue.delete()
  })
  return true
}

const updateNote = async (userUid, note) => {
  const db = getDb()
  await db.collection('pages').doc(userUid).update({
    [note.id]: note
  })
  return true
}

const getEncryptedEncryptionKey = async userUid => {
  const db = getDb()
  const docRef = db.collection('encryptionKeys').doc(userUid)
  const doc = await docRef.get()
  if (doc.exists) {
    const { key } = doc.data()
    return key
  } else {
    return null
  }
}

const setEncryptedEncryptionKey = async (userUid, encryptedEncryptionKey) => {
  const db = getDb()
  await db.collection('encryptionKeys').doc(userUid).set({ key: encryptedEncryptionKey })
  return encryptedEncryptionKey
}

const removeEncryptedEncryptionKey = async userUid => {
  const db = getDb()
  await db.collection('encryptionKeys').doc(userUid).delete()
  return true
}

const signOut = () => firebase.auth().signOut()

export {
  getFeedback,
  sendFeedback,
  getNotes,
  setNotes,
  deleteNote,
  updateNote,
  signOut,
  getEncryptedEncryptionKey,
  setEncryptedEncryptionKey,
  removeEncryptedEncryptionKey
}
